<template>
  <div>
    <NavBar></NavBar>
    <h1> PANTALLA DE ENVIAR ERRORES</h1>
  </div>
</template>

<script>
import NavBar from '../../../components/NavBar.vue'

export default {
  name: 'EnviarErrores',

  components: {
      'NavBar': NavBar
  }
}
</script>